const CSS_CLASSES = {
  modalContent: '.js-modal',
  formError: '.form-error'
};

const KEY_CODES = {
  escape: 27,
  enter: 13
};

const MEDIA_QUERIES = {
  // xs: '(max-width: 739px)',
  // sm: '(min-width: 740px) and (max-width: 959px)',
  // md: '(min-width: 960px) and (max-width: 1079px)',
  // lg: '(min-width: 1080px) and (max-width: 1439px)',
  // xl: '(min-width: 1440px)',
  small: '(max-width: 1079px)',
  large: '(min-width: 1080px)'
  // dark: '(prefers-color-scheme: dark)',
  // landscape: '(orientation: landscape)'
};

export { CSS_CLASSES, KEY_CODES, MEDIA_QUERIES };
